
import { z } from "zod";

export const aiJobInputSchema = z.object({
  title: z.string().min(1, "Job title is required"),
  company: z.string().min(1, "Company name is required"),
  location: z.string().min(1, "Location is required"),
  type: z.enum(["full-time", "part-time", "contract", "remote"]),
  department: z.string().optional(),
  team: z.string().optional(),
  reportingTo: z.string().optional(),
  experienceLevel: z.enum(["entry", "mid", "senior", "executive"]),
  salaryRange: z.object({
    min: z.number().optional(),
    max: z.number().optional(),
  }).optional(),
  keyResponsibilities: z.string().optional(),
  mustHaveSkills: z.string().optional(),
  niceToHaveSkills: z.string().optional(),
  companyDescription: z.string().optional(),
  benefits: z.string().optional(),
  additionalContext: z.string().optional(),
});

export type AIJobInputValues = z.infer<typeof aiJobInputSchema>;
